module.exports = __webpack_public_path__ + "img/mgh-toyosu-bayside-cross-tokyo-sp@2x.071fa3b1.jpg";